import React from 'react';
import './App.css';
import { OptionsCalculatorPage } from './pages/OptionsCalculator';
import {
  BrowserRouter,
  Navigate,
  NavLink,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <div style={{ display: "none" }}>
          <NavLink className={"nav-link"} to={"/options"}>Options Calculator</NavLink>
        </div>
        <AppRoutes />
        <footer style={{ textAlign: 'center', marginTop: '20px', borderTop: '1px solid #ccc' }}>
          <a href="https://legal.dysolix.dev/privacy" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </footer>
      </div>
    </BrowserRouter>
  );
}

function AppRoutes() {
  const location = useLocation();
  return (
    <Routes>
      <Route path='*' element={<Navigate to={"/options" + location.search} />} />
      <Route path="/options" element={<OptionsCalculatorPage />} />
    </Routes>
  )
}

export default App;
